<template>
  <div class="signin-page">
    <img
      class="layout__q-logo"
      src="/images/logo-small.svg"
    />
    <div class="signin-page-login">
      <div class="signin-page-login__logo">
          <img
            class="signin-page-login__logo__img"
            :src="`/images/logo.svg`"
            alt="OWQLO"
          />
      </div>
      <app-i18n
        class="signin-page-login__title"
        code="auth.signin"
      />

      <div class="signin-page-login__title-separator" />
      <el-form
        v-loading="loading"
        :model="model"
        :rules="rules"
        @keypress.enter.native="doSubmit"
        @submit.prevent.native="doSubmit"
        class="signin-page-login__form"
        ref="form"
        v-if="model"
      >
        <el-row>
          <!-- Email -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item :prop="fields.email.name">
              <el-input
                :placeholder="i18n('auth.fields.email')"
                prefix-icon="icon-mail"
                v-model="model[fields.email.name]"
              />
            </el-form-item>
          </el-col>

          <!-- Password -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item :prop="fields.password.name">
              <el-input
                :placeholder="i18n('auth.fields.password')"
                class="el-input--password"
                prefix-icon="icon-lock"
                show-password
                type="password"
                v-model="model[fields.password.name]"
              />
            </el-form-item>
          </el-col>

          <!-- Forgot password -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item
              class="signin-page-login__form__forgot-password el-form-item--short el-form-item--no-margin"
            >
              <router-link :to="{ path: '/auth/forgot-password' }">
                <app-i18n code="auth.forgotPassword.message" />
              </router-link>
            </el-form-item>
          </el-col>

          <!-- Remember me -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item
              :prop="fields.rememberMe.name"
              class="signin-page-login__form__remember-me el-form-item--short"
            >
              <el-checkbox v-model="model[fields.rememberMe.name]">
                <app-i18n code="auth.fields.rememberMe" />
              </el-checkbox>
            </el-form-item>
          </el-col>

          <!-- Form controls -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item class="signin-page-login__form__controls" >
              <el-button @click="doSubmit" type="primary" >
                <app-i18n code="auth.signin" />
              </el-button>
            </el-form-item>
          </el-col>

          <!-- Sign up -->
          <!-- <el-col :lg="24" :md="24" :sm="24">
            <el-form-item class="signin-page-login__form__sign-up el-form-item--short el-form-item--no-margin">
              <div class="signin-page-login__form__sign-up__wrapper">
                <app-i18n code="auth.noAccountYet" />
                <router-link
                  class="signin-page-login__form__sign-up__link"
                  :to="{ path: '/auth/signup' }"
                >
                  <app-i18n code="auth.signup" />
                </router-link>
              </div>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { i18n } from '@shared/i18n';
import { mapGetters, mapActions } from 'vuex';
import { UserModel } from '@modules/auth/user-model';

export default {
  name: 'app-signin-page',

  data() {
    return {
      model: {
        rememberMe: true,
      },
    };
  },

  computed: {
    ...mapGetters({
      loading: 'auth/loading',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    rules() {
      const { fields } = this;
      return {
        email: fields.email.forFormRules(),
        password: fields.password.forFormRules(),
        rememberMe: fields.rememberMe.forFormRules(),
      };
    },

    fields() {
      const { dateFormat, timeFormat} = this;
      return new UserModel({
        dateFormat, timeFormat
      }).fields();
    },
  },

  methods: {
    ...mapActions({
      doSigninSocial: 'auth/doSigninSocial',
      doSigninWithEmailAndPassword:
        'auth/doSigninWithEmailAndPassword',
    }),

    async doSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      await this.doSigninWithEmailAndPassword({
        email: this.model.email,
        password: this.model.password,
        rememberMe: this.model.rememberMe,
      });
    },
    i18n(code) {
      return i18n(code);
    },
  },
};
</script>

<style lang="scss" scoped>

.signin-page .layout__q-logo {
  width: 800px;
}

.signin-page-login {
  @include auth-mixin;

  background-color: white;
  position: absolute;
  width: 754px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
  padding: 4em 0 3em 0;

  &__form {
    @include mobile {
      width: 300px;
    }

    width: 350px;

    &__forgot-password {
      text-align: right;

      span {
        font-size: 12px;
        font-weight: 600;
        letter-spacing: -0.25px;
        color: #2acccc;
      }
      
    }

    &__remember-me {
      text-align: left;

      span {
        margin-left: 10px;
        font-size: 14px;
        font-weight: normal;
        letter-spacing: -0.3px;
        color: #333333;
      }

      @include mobile {
        margin-top: 16px;
      }
    }

    &__sign-up {
      &__wrapper {
        display: flex;
        align-content: center;
        justify-content: center;
      }

      &__link {
        margin-left: 5px;
        color: #2acccc;
        font-weight: bold;
      }
    }
    &__forgot-password,
    &__remember-me {
      @include small-mobile {
        text-align: center;
      }
    } 
  }
  @include small-mobile {
    padding-top: 6em;
  }
  @include mobile {
    width: 100vw;
    height: 100vh;
    display: grid;
    align-content: center;
  }
}
</style>
